import bsModal from 'bootstrap/js/dist/modal';
import sum from 'lodash/sum';

const printPageSection =
  (element, classes = []) => import('../../components/print')
    .then(module => module.printPageSection(element, classes));
export default {
  data() {
    return {
      averageMonthlySalary: '4000',
      load_contract_label: 'Charger les infos d\'un contrat',
      situation: 'couple',
      children: '1',
      /**
       * This child age is used for the tax credit for assmat only
       * as the parent is eligible if the child is not older than 6 years old
       */
      child_age: '0',
      /**
       * used to check if eligible for the cmg
       * If youngest child is older than 6 year then they are not eligible
       */
      youngestChildAge: 'less-than-six',
      other_aid_toggle: false,
      handicap_toggle: false,
      hourlyWageSetFromInput: false,
      other_aid: '0',
      month_week: 'week',
      monthly_worked_days: '',
      monthly_hours: '',
      has_overtime: false,
      monthly_overtime: '0',
      increase_overtime: '25',
      weekly_worked_days: '5',
      weekly_hours: '40',
      /**
       * 52 weeks - 5 weeks of holidays
       */
      yearlyWorkedWeeks: 47,
      totalYearlyWeeks: 52,
      yearly_weeks: '52',
      contract_ends_before_one_year: false,
      gross_daily_wage: '0',
      net_ratio_classic_france: null,
      net_ratio_classic_alsace_moselle: null,
      net_ratio_detax_france: null,
      net_ratio_detax_alsace_moselle: null,
      threshold: 0,
      social_contributions: {},
      cmgAidToggle: 'yes',
      isPublic: false,
      maxHoursYear: 744,
      isHourlyRateInRange: true,
    };
  },
  computed: {
    alsace_moselle() {
      return this.region === 'alsace_moselle';
    },
    alsace_moselle_french() {
      return this.alsace_moselle ? 'Oui' : 'Non';
    },
    children_i() {
      return Number(this.children);
    },
    child_age_option() {
      return this.child_age === '2' ? '0' : this.child_age;
    },
    cmgUnavailable() {
      return this.youngestChildTooOld || this.cmgAidToggle === 'no';
    },
    min_child_age_french() {
      return { 'less-than-six': 'moins de 6 ans', 'six-or-more': 'Plus de 6 ans' }[this.youngestChildAge];
    },
    situation_french() {
      return this.situation === 'single' ? 'parent seul' : 'en couple';
    },
    monthly_worked_days_f() {
      return parseFloat(this.monthly_worked_days.replace(',', '.'));
    },
    monthly_hours_f() {
      return parseFloat(this.monthly_hours.replace(',', '.'));
    },
    increase_overtime_i() {
      return Number(this.increase_overtime);
    },
    weekly_worked_days_f() {
      return parseFloat(this.weekly_worked_days.replace(',', '.'));
    },
    weekly_hours_f() {
      return parseFloat(this.weekly_hours.replace(',', '.'));
    },
    yearly_weeks_f() {
      const result = parseFloat(this.yearly_weeks.replace(',', '.'));
      if (this.contract_ends_before_one_year) {
        return result;
      } else {
        return Math.floor(result);
      }
    },
    other_aid_f() {
      return this.other_aid_toggle ? parseFloat(this.other_aid.replace(',', '.')) : 0;
    },
    net_ratio_detax() {
      return this.alsace_moselle ? this.net_ratio_detax_alsace_moselle : this.net_ratio_detax_france;
    },
    gross_mensualization() {
      return this.grossMonthlyWageRegular + this.grossMonthlyOvertimeWage;
    },
    gross_hourly_wage_f() {
      return parseFloat(this.gross_hourly_wage.replace(',', '.'));
    },
    net_mensualization_classic() {
      return this.grossMonthlyWageRegular * this.net_ratio_classic;
    },
    net_mensualization_detax() {
      return this.has_overtime ? (this.grossMonthlyOvertimeWage * this.net_ratio_detax) : 0;
    },
    net_mensualization() {
      return this.net_mensualization_classic + this.net_mensualization_detax;
    },
    net_monthy_overtime_increase() {
      return this.grossMonthlyOvertimeWagePremium * this.net_ratio_detax;
    },
    net_ratio_classic() {
      return this.alsace_moselle ? this.net_ratio_classic_alsace_moselle : this.net_ratio_classic_france;
    },
    net_partial_year_vacations_monthly() {
      return this.gross_partial_year_vacations_monthly * this.net_ratio_classic;
    },
    cmg_daily_salary_gross() {
      return (this.gross_mensualization + this.grossMonthlyOvertimeWagePremium) /
        Math.ceil(this.monthly_worked_days_f);
    },
    social_contributions_employee() {
      const amounts = [];

      for (const contribution in this.social_contributions) {
        amounts.push(this.social_contribution_amount(contribution, 'employee'));
      }

      return sum(amounts);
    },
    is_weekly_worked_days() {
      return this.weekly_worked_days !== '' && this.weekly_worked_days_f >= 0 && this.weekly_worked_days_f <= 7;
    },
    is_full_year() {
      return parseInt(this.yearly_weeks) === this.totalYearlyWeeks;
    },
    isWeek() {
      return this.month_week === 'week';
    },
    isMonth() {
      return this.month_week === 'month';
    },
    regular_hours() {
      return this.monthly_hours_f - (this.has_overtime ? this.monthlyOvertimeFloat : 0);
    },
    wageMonthlyExceeded() {
      return this.cmg_daily_salary_gross > this.threshold;
    },
    social_contributions_employer() {
      const amounts = [];

      for (const contribution in this.social_contributions) {
        amounts.push(this.social_contribution_amount(contribution, 'employer'));
      }

      return sum(amounts);
    },
    is_monthly_hours() {
      return this.monthly_hours !== '' && this.monthly_hours_f >= 0 && this.monthly_hours_f <= this.maxHoursYear;
    },
    is_monthly_worked_days() {
      return this.monthly_worked_days !== '' && this.monthly_worked_days_f >= 0 && this.monthly_worked_days_f <= 31;
    },
    is_monthly_overtime() {
      return this.has_overtime && this.monthly_overtime !== '' && this.monthlyOvertimeFloat >= 0 &&
        this.monthlyOvertimeFloat <= 140;
    },
    partial_year_vacations_10_percent_yearly_gross() {
      return this.gross_mensualization * 12 * 0.1;
    },
    /**
     * le nombre de jour acquis multiplié par la valeur d'un jour de congé
     * @returns {number}
     */
    partial_year_vacations_maintains_salary_yearly_gross() {
      return this.partial_acquired_days * this.daily_maintain_vacation_maintain_gross;
    },
    /**
     * 2,5 jours de congés acquis toutes les 4 semaines travaillées, et arrondi au supérieur
     * @returns {number}
     */
    partial_acquired_days() {
      return Math.ceil(Math.min((2.5 * (this.yearly_weeks_f / 4)), 30));
    },
    /**
     * la valeur d'un jour de congé est obtenu par le coût par semaine divisé par 6
     * (6 jours ouvrables par semaine)
     * @returns {number}
     */
    daily_maintain_vacation_maintain_gross() {
      return (this.weekly_maintain_vacation_maintain_gross) / 6.0;
    },
    /**
     * la valeur d'une semaine de congés est obtenue par mensualisation ramenée à l'année,
     * divisée par le nombre de semaines effectives.
     * @returns {number}
     */
    weekly_maintain_vacation_maintain_gross() {
      return (this.gross_mensualization * 12 / this.yearly_weeks_f);
    },
    gross_partial_year_vacations_monthly() {
      return Math.max(
        this.partial_year_vacations_10_percent_yearly_gross,
        this.partial_year_vacations_maintains_salary_yearly_gross
      ) / 12.0;
    },
    averageMonthlySalaryParsed() {
      return parseFloat(this.averageMonthlySalary.replace(',', '.'));
    },
    maxCMGHelpExceeded() {
      return this.realHourlyRateNet > this.maxNetHelp;
    },
  },
  methods: {
    /**
     * We convert the displayed value that contains a comma into a float with two decimal point
     */
    shownStringToFloat(val) {
      if (typeof val === 'string') {
        const convertedValue = parseFloat(val.replace(',', '.'));
        return convertedValue.toFixed(2);
      }
      return val;
    },
    toggleMW() {
      if (this.month_week === 'month') this.monthFromWeek();
      if (this.month_week === 'week') this.weekFromMonth();

      const that = this;
      setTimeout(function() {
        that.checkErrors();
      });
    },
    injectAgeOptions(parentSituation) {
      const select = document.querySelector('.cmg-simulator__min-child-age');
      if (!select) return;

      // Prevent duplicate injection
      this.removeInjectedAgeOptions();

      const ageOptions = parentSituation === 'single' ? this.singleParentChildAgeOptions : this.coupleChildAgeOption;

      ageOptions.forEach(opt => {
        const option = document.createElement('option');
        option.value = opt.value;
        option.text = opt.text;
        select.appendChild(option);
      });

      // reset options to first option
      // needs the timeout as there is an incomplete transition that makes the code not execute
      setTimeout(() => { select.selectedIndex = 0; }, 10);
    },
    removeInjectedAgeOptions() {
      const select = document.querySelector('.cmg-simulator__min-child-age');
      if (!select) return;

      const options = Array.from(select.options);
      options.forEach(opt => {
        if (this.singleParentChildAgeOptions.map(obj => obj.value.toString()).includes(opt.value.toString())) {
          select.removeChild(opt);
        }
      });
    },
    monthFromWeek() {
      this.monthly_worked_days = this.is_weekly_worked_days && this.isYearlyWeeks
        ? this.toFloatForDisplay(this.weekly_worked_days_f *
          (this.yearly_weeks_f / 12), 4)
        : '';
      this.monthly_hours = this.isWeeklyHours && this.yearly_weeks
        ? this.toFloatForDisplay(this.weekly_hours_f *
          (this.yearly_weeks_f / 12), 4)
        : '';

      if (this.has_overtime) {
        const overtimeWeekly = this.weeklyOvertimeFloat;
        const overtimeDaily = overtimeWeekly / this.weekly_worked_days_f;
        const overtimeMonthly = overtimeDaily * this.monthly_worked_days_f;

        this.monthly_overtime = isNaN(overtimeMonthly) ? '0' : this.toFloatForDisplay(overtimeMonthly, 4);
      } else this.monthly_overtime = '0';
    },
    social_contribution_base(name) {
      const contribution = this.social_contributions[name];

      switch (contribution.base) {
        case 'total':
          return this.grossTotal;
        case 'base_normal_9825':
          return (this.grossTotal - this.social_contributions_detax_base()) * 0.9825;
        case 'base_detax_9825':
          return this.social_contributions_detax_base() * 0.9825;
        case 'base_exonerated_heures_sup_comp':
          return this.social_contributions_detax_base();
        case 'base_social':
          return 0;
        default:
          return this.grossTotal;
      }
    },
    social_contributions_detax_base() {
      return this.grossMonthlyOvertimeWage + this.grossMonthlyOvertimeWagePremium;
    },
    social_contribution_amount(name, role) {
      if (!this.isSocialContributionRelevant(name)) return 0;

      const rate = this.social_contributions[name][role + '_rate'];
      if (rate === 0) return 0;

      const base = this.social_contribution_base(name);

      const amount = base * (rate / 100.0);
      const maximumAmount = this.social_contributions[name][role + '_max'] ?? amount;

      return Math.min(amount, maximumAmount);
    },
    set_gross_hourly_wage(value) {
      this.gross_hourly_wage = value;
      this.recreate_gross_hourly_wage_slider();
    },
    to_money(val) {
      return isNaN(val) ? '?' : this.toFloatForDisplay(Math.round10(val, -2), 2) + '\xa0€';
    },
    to_decimal4(val) {
      return isNaN(val) ? '?' : Math.round10(val, -4).toString().replace('.', ',');
    },
    destroy_gross_hourly_wage_slider() {
      this.slider.destroy();
    },
    recreate_gross_hourly_wage_slider() {
      this.destroy_gross_hourly_wage_slider();
      this.createWageSlider();
    },
    addBlur() {
      this.$nextTick(function() {
        $('.blur').addClass('blurring');
      });
    },
    print() {
      printPageSection('#cmg-simulator__print', ['cmg-simulator']);
    },
    toFloatForDisplay(float, digits) {
      return float.toFixed(digits).replace('.', ',');
    },
    adjustHourlyRate(adjustment) {
      let hourlyWage = this.gross_hourly_wage_f;
      hourlyWage = adjustment === 'increase' ? hourlyWage + 0.01 : hourlyWage - 0.01;
      this.slider.set(hourlyWage);
      hourlyWage = this.toFloatForDisplay(hourlyWage, 2);
      this.gross_hourly_wage = hourlyWage;
      this.grossHourlyWageInput = hourlyWage;
    },
    updateHourlyWage() {
      // we set this variable so that the event that updates the slider
      // does not interfere with the input itself
      this.hourlyWageSetFromInput = true;
      const hourlyWage = parseFloat(this.grossHourlyWageInput.replace(',', '.'));
      if (hourlyWage <= this.maximumGrossHourlyWage || hourlyWage >= this.minimumGrossHourlyWage) {
        this.gross_hourly_wage = this.toFloatForDisplay(hourlyWage, 2);
        this.slider.set(hourlyWage);
      }
      this.hourlyWageSetFromInput = false;
    },
  },
  watch: {
    maximumGrossHourlyWage() {
      this.recreate_gross_hourly_wage_slider();
    },
    month_week(newVal, oldVal) {
      this.toggleMW();
      if (oldVal === 'other' && this.isPublic) {
        this.addBlur();
      }
    },
    weekly_worked_days() {
      this.monthFromWeek();
      this.checkErrors();
    },
    yearly_weeks() {
      if (this.month_week === 'week') this.monthFromWeek();

      // via le cmg_load, on peut être amené à charger un contrat de type ends_before_one_year.
      // on a du coup été obligé d'autoriser les virgules sur le champs.
      // l'attribut yearly_weeks_f est remis en integer si nécessaire.
      // On le ré-injecte donc ici à nouveau ensuite
      this.yearly_weeks = isNaN(this.yearly_weeks_f) ? '' : this.to_decimal4(this.yearly_weeks_f).toString().replace('.', ',');
      this.checkErrors();
    },
    monthly_worked_days() {
      this.checkErrors();
    },
    monthly_hours() {
      this.checkErrors();
    },
    monthly_overtime() {
      this.checkErrors();
    },
    youngestChildAge() {
      if (this.youngestChildAge !== 'less-than-six') {
        this.child_age = 6;
      }
    },
    isPublic(val) {
      if (val) {
        this.addBlur();
        $('body').on('click', '.blurring', function() {
          const modalElement = document.getElementById('member-only-result');
          const modal = bsModal.getOrCreateInstance(modalElement);
          modal.show();
        });
      }
    },
    alsace_moselle() {
      const $otherRegionInput = $('input.other_regions');
      $otherRegionInput.prop('checked', this.alsace_moselle);
      $otherRegionInput.change();
    },
    handicap_toggle() {
      const $handicapToggle = $('input.handicap_toggle');
      $handicapToggle.prop('checked', this.handicap_toggle);
      $handicapToggle.change();
    },
    other_aid_toggle() {
      const $otherAidToggle = $('input.other_aid_toggle');
      $otherAidToggle.prop('checked', this.other_aid_toggle);
      $otherAidToggle.change();
    },
    grossHourlyWageInput(val) {
      const floatValue = this.shownStringToFloat(val);
      this.isHourlyRateInRange = !(floatValue > this.maximumGrossHourlyWage || floatValue < this.minimumGrossHourlyWage);
    },
    situation(newVal) {
      this.injectAgeOptions(newVal);
    },
    isCustomMonthlySalary() {
      if (this.isPublic) {
        this.addBlur();
      }
    },
  },
};
